import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { adminLogin, adminMe, setToken, getToken } from "@/lib/api";

const Ctx = createContext(null);

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = unauth, object = admin

  useEffect(() => {
    if (!getToken()) {
      setUser(false);
      return;
    }
    adminMe()
      .then(setUser)
      .catch(() => {
        setToken(null);
        setUser(false);
      });
  }, []);

  const login = async (email, password) => {
    const data = await adminLogin(email, password);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = () => {
    setToken(null);
    setUser(false);
  };

  return <Ctx.Provider value={{ user, login, logout }}>{children}</Ctx.Provider>;
}

export const useAdminAuth = () => useContext(Ctx);

export function RequireAdmin({ children }) {
  const { user } = useAdminAuth();
  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-100 text-slate-400">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
